export const getBrandsSectionId = (key: string) => `brands-${key}`;

export const getBrandSectionLink = (key: string) => {
  const url = new URL(window.location.toString());
  url.hash = `#${getBrandsSectionId(key)}`;

  return url.toString();
};
